import { render } from "./NotificationWrapper.vue?vue&type=template&id=1e44f3b7&scoped=true"
import script from "./NotificationWrapper.vue?vue&type=script&lang=js"
export * from "./NotificationWrapper.vue?vue&type=script&lang=js"

import "./NotificationWrapper.vue?vue&type=style&index=0&id=1e44f3b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e44f3b7"]])

export default __exports__